import { WithdrawProvider } from '../../../../app/contexts/WithdrawContext'
import { SellerCommissionTable } from './components/SellerCommissionTable'

export const SellerCommissionPage = () => {
  return (
    <WithdrawProvider>
      <div className="w-full">
        <SellerCommissionTable />
      </div>
    </WithdrawProvider>
  )
}
